import {
	GET_VIDEO_PLAYLIST_START, GET_VIDEO_PLAYLIST,
	RESET_VIDEO_PLAYLIST,
} from '../constants';

const initialState = {};

const video = (state = initialState, {type, data}) => {
	switch (type) {
		case GET_VIDEO_PLAYLIST_START:
			return {
				...state,
				playlist: {
					...data,
				},
			};
		case GET_VIDEO_PLAYLIST: {
			return {
				...state,
				playlist: {
					...state.playlist,
					...data,
				},
			};
		}
		case RESET_VIDEO_PLAYLIST: {
			return {
				...state,
				playlist: {},
			};
		}
		default:
			return state;
	}
};

export default video;
